module.exports = __webpack_public_path__ + "img/poster_tem_4.230f607d.png";